import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, CustomInput } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

function EditableRow(props) {
  return (
    <Row
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: 'unset',
        padding: 0,
      }}
      className={props.className}
    >
      {props.children && <Col style={{ padding: 0 }}>{props.children}</Col>}
      <Col
        style={{
          ...props?.checkboxStyle,
          maxWidth: '20%',
          marginLeft: 5,
        }}
      >
        <CustomInput
          onChange={e => {
            props.onChange(e.target.id)
          }}
          type="switch"
          id={props.switchId}
          checked={props.isChecked}
          name="customSwitch"
          inline
        >
          <SwitchLabel>
            <FormattedMessage id="Edit" />
          </SwitchLabel>
        </CustomInput>
      </Col>
    </Row>
  )
}

const SwitchLabel = styled.span`
  padding-left: 1rem;
  align-self: center;

  @media ${queries.less.mdl} {
    display: none;
  }
`

EditableRow.propTypes = {
  switchId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
}

export default EditableRow
